require("!!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/node_modules/raw-loader/index.js!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/assets/nomadic-admin-components.mjs"))


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/script-loader!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/assets/nomadic-admin-components.mjs
// module id = ../../../../script-loader/index.js!../../../../../src/assets/nomadic-admin-components.mjs
// module chunks = 4